import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      width: '100%',
    },
    cardContainer: {
      padding: 16,
      backgroundColor: theme.palette.background.alternative,
      maxWidth: 400,
      width: '100%',
      borderRadius: 16,
      gap: 20,
    },
    cardTitle: {
      marginBottom: 8,
    },
    cardBrandIcon: {
      width: 48,
      height: 32,
    },
    installmentBox: {
      padding: 12,
      border: `1px solid ${theme.palette.border.default}`,
      borderRadius: 8,
      minWidth: 80,
      gap: 8,
    },
  });

export default styles;
